module.exports = __webpack_public_path__ + "static/all_doulas-fea1ca002a3560df3db9fc289c61239a.jpg";